import { render, staticRenderFns } from "./KeywordsTopTenModal.vue?vue&type=template&id=0ac5f4f1&"
import script from "./KeywordsTopTenModal.vue?vue&type=script&lang=js&"
export * from "./KeywordsTopTenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports